// dmaReducer.js

import {
  CLEAR_SELECTED_DMAS,
  SET_SELECTED_DMAS,
} from "../../../thunks/common-thunks/Actions";

const initialState = {
  selectedDMAs: [],
};

const dmaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_DMAS:
      return {
        ...state,
        selectedDMAs: Array.isArray(action.payload)
          ? action.payload
          : [action.payload],
      };
    case CLEAR_SELECTED_DMAS:
      return {
        ...state,
        selectedDMAs: [],
      };
    default:
      return state;
  }
};

export default dmaReducer;
